module.exports = ":host {\n  height: calc(100% - 52px - 30px); }\n\nbutton {\n  width: 100%; }\n"